var _defs, _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoSimpleinline = function SvgLogoSimpleinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "logoSimple_inline_svg__Layer_1",
    x: 0,
    y: 0,
    "data-simple": "true",
    style: {
      enableBackground: "new 0 0 800 450"
    },
    viewBox: "150 150 150 160"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logoSimple_inline_svg__header-shape-gradient",
    x2: 0.35,
    y2: 1,
    gradientTransform: "rotate(27)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "var(--color-stop)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "var(--color-bot)"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".logoSimple_inline_svg__st0{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m181.9 195.9-15.7-31.4h31.5l5-10H150l26.3 52.6zM257.5 241.8l26.3 52.7h-52.6l-21.3-42.7-5.6 11.2 20.7 41.5h75l-33.4-66.8c-2.9 1.6-5.9 3-9.1 4.1z",
    className: "logoSimple_inline_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M286.1 166.8c-4.8-7.7-13-12.3-22.1-12.3h-39l-75 150h11.2l70-140H264c5.6 0 10.7 2.8 13.6 7.6 2.9 4.8 3.2 10.6.7 15.6L268.2 208c-5.1 10.2-15.4 16.6-26.8 16.6h-17.8l-5 10h22.8c15.2 0 29-8.5 35.8-22.1l10.1-20.3c4-8.2 3.6-17.7-1.2-25.4z",
    className: "logoSimple_inline_svg__st0"
  })));
};
export default SvgLogoSimpleinline;